import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { createEventType, editEventType } from '../../actions/ads'
import { Input, Checkbox } from '../../components/ModalInputs'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.scss'

const INITIAL_VALUES = {
  ev_type: '',
  reporthse: 0
}

const validationSchema = Yup.object().shape({
  ev_type: Yup.string()
    .required('Обязательное поле')
    .max(256, 'Должно быть не более 256 символов'),
})

const EventTypeModal = ({ open, onClose, data, addMode }) => {
  const dispatch = useDispatch()
  const [confirmation, setConfirmation] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const createItem = useCallback(async (values) => {
    setIsSubmitting(true)
    try {
      const success = await dispatch(createEventType(values))
      if (success) onClose()
    } finally {
      setIsSubmitting(false)
    }
  }, [dispatch, onClose])

  const updateItem = useCallback(async (values) => {
    setIsSubmitting(true)
    try {
      const success = await dispatch(editEventType(values))
      if (success) onClose()
    } finally {
      setIsSubmitting(false)
    }
  }, [dispatch, onClose])

  const {
    values,
    errors,
    touched,
    dirty,
    handleBlur,
    handleSubmit,
    handleChange,
    setValues,
    setFieldValue,
    resetForm
  } = useFormik({
    initialValues: INITIAL_VALUES,
    enableReinitialize: true,
    validationSchema,
    onSubmit: addMode ? createItem : updateItem
  })

  useEffect(() => {
    if (!open) {
      resetForm()
      return
    }
    setValues(addMode ? INITIAL_VALUES : data)
  }, [open, addMode, data, setValues, resetForm])

  const handleCloseModal = useCallback(() => {
    if (dirty) {
      setConfirmation(true)
    } else {
      onClose()
    }
  }, [dirty, onClose])

  const acceptConfirmation = useCallback(() => {
    onClose()
    setConfirmation(false)
  }, [onClose])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(false)
  }, [])

  const handleCheckboxChange = useCallback(() => {
    setFieldValue('reporthse', Number(!values.reporthse))
  }, [setFieldValue, values.reporthse])

  const getError = useCallback((fieldName) =>
    touched[fieldName] && errors[fieldName],
    [touched, errors]
  )

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      classNames={{ modal: styles.modal }}
      closeOnEsc={!dirty}
      closeOnOverlayClick={!dirty}
      showCloseIcon={false}
      animationDuration={200}
      center
    >
      <form onSubmit={handleSubmit} className={styles.modalForm}>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление типа события' : 'Редактирование типа события'}</h2>

          <Input
            name="ev_type"
            label="Название"
            value={values.ev_type || ''}
            error={getError('ev_type')}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isSubmitting}
            autoFocus
          />

          <Checkbox
            name="reporthse"
            label="Отчет ВШЭ"
            checked={!!values.reporthse}
            onChange={handleCheckboxChange}
            disabled={isSubmitting}
          />
        </div>

        <div className={styles.modalFooter}>
          <div className={styles.footerInfo} />
          <div className={styles.footerButtons}>
            <Button
              mode="white"
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting || !dirty}
            >
              Сохранить
            </Button>
            <Button
              mode="white"
              type="button"
              onClick={handleCloseModal}
              disabled={isSubmitting}
            >
              Закрыть
            </Button>
          </div>
        </div>
      </form>

      {confirmation && (
        <Confirmation
          title="Есть несохраненные данные. Уверены что хотите выйти?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}

export default EventTypeModal
